import { BASE_URL } from "@/config";
import { getAuthHeader } from "@/lib/utils";
import axios from "axios";

const getVehicleClasses = async () => {
    let classes: any[] = [];
    var response = await axios.get(`${BASE_URL}/vehicle-classes`, {
        headers: getAuthHeader()
    });

    if (Array.isArray(response?.data)) {
        classes = response.data;
    }
    else {
        console.error("Unexpected getLocations format:", response);
    }

    return classes;
};

const createVehicleClass = async (data: any) => {
    data.base_price = parseFloat(data.base_price) || null;

    const response = await axios.post(`${BASE_URL}/vehicle-classes`, data, {
        headers: getAuthHeader()
    });

    return response;
}

const editVehicleClass = async (id: number, data: any) => {
    data.base_price = parseFloat(data.base_price) || null;

    const response = await axios.patch(`${BASE_URL}/vehicle-classes/${id}`, data, {
        headers: getAuthHeader()
    });
    return response;
}

const deleteVehicleClass = async (id: number) => {
    const response = await axios.delete(`${BASE_URL}/vehicle-classes/${id}`, {
        headers: getAuthHeader()
    });
    return response;
}

const getClassPrices = async (id?: number) => {
    if(!id) {
        return [];
    }
    
    const response = await axios.get(`${BASE_URL}/vehicle-classes/${id}/prices`,
        {
            headers: getAuthHeader()
        }
    );
    if (Array.isArray(response?.data)) {
        return response.data;
    } else {
        console.error("Unexpected getClassPrices format:", response);
        return [];
    }
}

const createVehicleClassPrice = async (classId: number, data: any) => {

    data = {
        price: parseFloat(data.price) || null,
        start_date: new Date(data.start).toISOString(),
        end_date: new Date(data.end).toISOString(),
    }
    const response = await axios.post(`${BASE_URL}/vehicle-classes/${classId}/prices`, data, {
        headers: getAuthHeader()
    });

    return response;
}

const deleteVehicleClassPrice = async (classId: number, priceId: number) => {
    const response = await axios.delete(`${BASE_URL}/vehicle-classes/${classId}/prices/${priceId}`, {
        headers: getAuthHeader()
    });
    return response;
}

const getVehiclePrices = async (id?: number) => {
    if(!id) {
        return [];
    }
    const response = await axios.get(`${BASE_URL}/pricing?filter={"vehicle_id":${id}}&start=1&end=10000`, {
        headers: getAuthHeader()
    });
    if (Array.isArray(response?.data)) {
        return response.data;
    } else {
        console.error("Unexpected getVehiclePrices format:", response);
        return [];
    }
}

const createVehiclePrice = async (data: any) => {
    data = {
        vehicle_id: data.vehicleId,
        seasonal_rate: parseFloat(data.price) || null,
        start_date: new Date(data.start).toISOString(),
        end_date: new Date(data.end).toISOString(),
        base_price: 0
    }
    const response = await axios.post(`${BASE_URL}/pricing/device`, data, {
        headers: getAuthHeader()
    });
    return response;
}

const deleteVehiclePrice = async (id: number) => {
    const response = await axios.delete(`${BASE_URL}/pricing/${id}`, {
        headers: getAuthHeader()
    });
    return response;
}

export {
    getVehicleClasses,
    createVehicleClass,
    deleteVehicleClass,
    editVehicleClass,
    getClassPrices,
    createVehicleClassPrice,
    deleteVehicleClassPrice,
    getVehiclePrices,
    deleteVehiclePrice,
    createVehiclePrice
};